// extracted by mini-css-extract-plugin
export default {"section":"About_section__QIx4N","grid":"About_grid__spcqp","panel":"About_panel__fsmlh"};